const ObservationsStatusNotificationToggle = (options = {}) => {
  const _defaults = {
    statusSelectSelector: '#status-select',
    notificationSelector: '.c-observationsEdit__resolvedNotification',
  };

  const settings = { ..._defaults, ...options };

  let statusSelect, notification, emailSent;

  const toggleNotification = () => {
    if (
      (statusSelect.value === 'resolved' || statusSelect.value === 'closed') &&
      !emailSent
    ) {
      notification.style.display = 'flex';
    } else {
      notification.style.display = 'none';
    }
  };

  // Public: Initialise module
  const init = () => {
    statusSelect = document.querySelector(settings.statusSelectSelector);
    notification = document.querySelector(settings.notificationSelector);

    if (!statusSelect || !notification) return;

    emailSent = statusSelect.dataset.emailSent === 'true';

    statusSelect.addEventListener('change', toggleNotification);
  };

  // Public: Remove event listeners
  const destroy = () => {
    if (statusSelect) {
      statusSelect.removeEventListener('change', toggleNotification);
    }
  };

  // Public: Reinitialize the module (destroy then init)
  const reinit = () => {
    destroy();
    init();
  };

  return {
    init,
    destroy,
    reinit,
  };
};

export default ObservationsStatusNotificationToggle;
